import { memo } from 'react'
import { AboutUs } from '../../assets/images/svg/aboutUs'
import { AddUserIcon } from '../../assets/images/svg/AddUserIcon'
import BankIcon from '../../assets/images/svg/BankIcon'
import { BhimUpi } from '../../assets/images/svg/bhimUpi'
import { BillIcon } from '../../assets/images/svg/BillIcon'
import {
  BhimIcon,
  Broadband,
  Cable,
  Charity,
  Clubs,
  CreditCard,
  Cylinder,
  DataCard,
  Dth,
  Education,
  Electricity,
  FailedIconFilled,
  FastTag,
  Gas,
  GiftCard,
  GooglePlay,
  Hospitality,
  HousingSociety,
  InstantOnboard,
  Insurance,
  Jio,
  Landline,
  Loan,
  Mobile,
  MutualFund,
  NoAdditionalCharges,
  PaymentIcon,
  PendingIconFilled,
  RecurringDeposits,
  Rentals,
  Subscription,
  SuccessIconFilled,
  Tax,
  Toll,
  TouchIcon,
  Water,
} from '../../assets/images/svg/BillPaymentIcons'
import { BillPaymentRupeeIcon } from '../../assets/images/svg/BillPaymentRupeeIcon'
import BizzLogo from '../../assets/images/svg/BizzLogo'
import { CalculatorIcon } from '../../assets/images/svg/CalculatorIcon'
import { Calendar } from '../../assets/images/svg/Calendar'
import Camera from '../../assets/images/svg/Camera'
import { CaretIcon } from '../../assets/images/svg/CarentIcon'
import { ChatbotAwareness, ChatIcon } from '../../assets/images/svg/ChatbotAwareness'
import { CheckboxOff, CheckboxOn } from '../../assets/images/svg/CheckboxOnOff'
import Close from '../../assets/images/svg/Close'
import { ContactsIcon } from '../../assets/images/svg/ContactsIcon'
// import { Copy } from '../../assets/images/svg/copy'
import BluetoothIcon from '../../assets/images/svg/BluetoothIcon'
import BluetoothSymbol from '../../assets/images/svg/BluetoothSymbol'
import ChatbotIcon from '../../assets/images/svg/ChatbotIcon'
import { Copy } from '../../assets/images/svg/copy'
import { DeleteIcon } from '../../assets/images/svg/DeleteIcon'
import Document from '../../assets/images/svg/Document'
import { DocumentIcon } from '../../assets/images/svg/DocumentIcon'
import DocumentWithDot from '../../assets/images/svg/DocumentWithDot'
import { DownArrow } from '../../assets/images/svg/downArrow'
import Download from '../../assets/images/svg/Download'
import DownloadFile from '../../assets/images/svg/DownloadFile'
import { EditIcon } from '../../assets/images/svg/EditIcon'
import { NoSettlement } from '../../assets/images/svg/emptySettlement'
import { NoTransaction } from '../../assets/images/svg/emptyTransaction'
import { Error } from '../../assets/images/svg/Error'
import ErrorBadge from '../../assets/images/svg/ErrorBadge'
import ErrorTxn from '../../assets/images/svg/ErrorTxn'
import { EyeVisibleOff } from '../../assets/images/svg/EyeVisibleOff'
import { EyeVisibleOn } from '../../assets/images/svg/EyeVisibleOn'
import { FaqArrowRight } from '../../assets/images/svg/FaqArrowRight'
import HeaderArrowLeft from '../../assets/images/svg/headerArrowLeft'
import { HelpIcon } from '../../assets/images/svg/HelpIcon'
import { HomeTabIcon } from '../../assets/images/svg/HomeTabIcon'
import IconArrowNext from '../../assets/images/svg/IconArrowNext'
import InfoIcon from '../../assets/images/svg/InfoIcon'
import { ItemChecked } from '../../assets/images/svg/ItemChecked'
import { ItemUnChecked } from '../../assets/images/svg/ItemUnChecked'
import { JioLogo } from '../../assets/images/svg/jioLogo'
import { JioPay } from '../../assets/images/svg/jioPay'
import { JioPayChicmicStrip } from '../../assets/images/svg/JioPayChicmicStrip'
import { JioPayOnLightBackground } from '../../assets/images/svg/jioPayDarkBg'
import { JioPayLight } from '../../assets/images/svg/jioPayLight'
import { JioPayLightDarkBg } from '../../assets/images/svg/jioPayLightDarkBg'
import { JioPayLogo, JioPayWhiteText } from '../../assets/images/svg/JioPayWhiteText'
import { JpbRupeeSymbol } from '../../assets/images/svg/jpbRupeeSymbol'
import LanguageIcon from '../../assets/images/svg/LanguageIcon'
import Logout from '../../assets/images/svg/Logout'
import { MailIcon } from '../../assets/images/svg/MailIcon'
import { ManageUsersIcon } from '../../assets/images/svg/ManageUsersIcon'
import { MobileIcon } from '../../assets/images/svg/MobileIcon'
import { MoreIcon } from '../../assets/images/svg/MoreIcon'
import { MoreTabIcon } from '../../assets/images/svg/MoreTabIcon'
import MyAccountIcon from '../../assets/images/svg/MyAccountIcon'
import MyDeviceIcon from '../../assets/images/svg/MyDeviceIcon'
import NoDeviceLinked from '../../assets/images/svg/NoDeviceLinked'
import { NoSearchResultFound } from '../../assets/images/svg/noSearchResultFound'
import NotificationIcon from '../../assets/images/svg/NotificationIcon'
import { PaymentLinkIcon } from '../../assets/images/svg/PaymentLinkIcon'
import { PlayIcon } from '../../assets/images/svg/playIcon'
import ProfileIcon from '../../assets/images/svg/ProfileIcon'
import { ProfileIconFilled } from '../../assets/images/svg/ProfileIconFilled'
import { ProtectAccount } from '../../assets/images/svg/protectAccount'
import { ProtectAccountSmall } from '../../assets/images/svg/ProtectAccountSmall'
import { QrIcon } from '../../assets/images/svg/QrIcon'
import { QrTabIcon } from '../../assets/images/svg/QrTabIcon'
import RefreshIcon from '../../assets/images/svg/RefreshIcon'
import RefundIcon from '../../assets/images/svg/RefundIcon'
import Report from '../../assets/images/svg/Report'
import { RupeeIcon } from '../../assets/images/svg/RupeeIcon'
import RupeeIconBillPayment from '../../assets/images/svg/RupeeIconBillPayment'
import { RupeeIconFilled } from '../../assets/images/svg/RupeeIconFilled'
import { RupeeIconRepeated } from '../../assets/images/svg/RupeeIconRepeated'
import { RupeeTabIcon } from '../../assets/images/svg/RupeeTabIcon'
import { SearchIcon } from '../../assets/images/svg/SearchIcon'
import SettlementIcon from '../../assets/images/svg/SettlementIcon'
import Share from '../../assets/images/svg/Share'
import Splash from '../../assets/images/svg/splash'
import StatusLoading from '../../assets/images/svg/StatusLoading'
import StatusRupeeIcon from '../../assets/images/svg/StatusRupeeIcon'
import StatusSuccess from '../../assets/images/svg/StatusSuccess'
import { Store } from '../../assets/images/svg/store'
import SuccessIconTick, { SuccessIconTickSmall } from '../../assets/images/svg/SuccessIconTick'
import { Support } from '../../assets/images/svg/support'
import SupportIcon from '../../assets/images/svg/SupportIcon'
import Swap from '../../assets/images/svg/Swap'
import { TimerIcon } from '../../assets/images/svg/TimerIcon'
import { TransactionHistoryIcon } from '../../assets/images/svg/TransactionHistoryIcon'
import { TransactionIcon } from '../../assets/images/svg/TransactionIcon'
import Triangle from '../../assets/images/svg/Triangle'
import Union from '../../assets/images/svg/Union'
import { UpArrow } from '../../assets/images/svg/uparrow'
import WarningIcon, { WarningIconError } from '../../assets/images/svg/WarningIcon'

interface SvgProps {
  imageName: string
  height?: number
  width?: number
  color?: any
  textColor?: any
}

export const SvgImage = memo(({ imageName, width, height, color, textColor }: SvgProps) => {
  const SvgList: any = {
    NoTransaction: <NoTransaction />,
    JioLogo: <JioLogo />,
    NoSearchResult: <NoSearchResultFound color={color} />,
    JioPay: <JioPay />,
    NoSettlement: <NoSettlement />,
    ProtectAccount: <ProtectAccount color={color} />,
    ProtectAccountSmall: <ProtectAccountSmall color={color} textColor={textColor} />,
    JpbRupeeSymbol: <JpbRupeeSymbol />,
    PlayIcon: <PlayIcon />,
    JioPayLight: <JioPayLight />,
    JioPayLightDarkBg: <JioPayLightDarkBg textColor={textColor} color={color} />,
    JioPayWhiteText: <JioPayWhiteText textColor={textColor} width={width} height={height} />,
    JioPayLogo: <JioPayLogo textColor={textColor} width={width} height={height} />,
    BhimUpi: <BhimUpi width={width} height={height} color={color} />,
    Support: <Support />,
    AboutUs: <AboutUs />,
    Splash: <Splash width={width} height={height} />,
    JioPayOnLightBackground: <JioPayOnLightBackground />,
    UpArrow: <UpArrow />,
    DownArrow: <DownArrow />,
    JioPayChicmicStrip: <JioPayChicmicStrip />,
    transactionsIcon: <TransactionIcon width={width} height={height} color={color} />,
    copy: <Copy width={width} height={height} color={color} />,
    eyeVisibleOff: <EyeVisibleOff width={width} height={height} />,
    eyeVisibleOn: <EyeVisibleOn width={width} height={height} />,
    store: <Store width={width} height={height} color={color} />,
    QrIcon: <QrIcon width={width} height={height} color={color} />,
    RupeeIcon: <RupeeIcon width={width} height={height} color={color} />,
    StatusSuccess: <StatusSuccess width={width} height={height} color={color} />,
    StatusError: <StatusSuccess width={width} height={height} color={color} />,
    Share: <Share width={width} height={height} color={color} />,
    Download: <Download width={width} height={height} color={color} />,
    StatusLoading: <StatusLoading width={width} height={height} color={color} />,
    IconArrowNext: <IconArrowNext width={width} height={height} color={color} />,
    StatusRupeeIcon: <StatusRupeeIcon width={width} height={height} color={color} />,
    Close: <Close width={width} height={height} color={color} />,
    Swap: <Swap width={width} height={height} color={color} />,
    Union: <Union width={width} height={height} color={color} />,
    Camera: <Camera width={width} height={height} color={color} />,
    ProfileIcon: <ProfileIcon width={width} height={height} color={color} />,
    SettlementIcon: <SettlementIcon width={width} height={height} color={color} />,
    NotificationIcon: <NotificationIcon width={width} height={height} color={color} />,
    LanguageIcon: <LanguageIcon width={width} height={height} color={color} />,
    SupportIcon: <SupportIcon width={width} height={height} color={color} />,
    MyDeviceIcon: <MyDeviceIcon width={width} height={height} color={color} />,
    BankIcon: <BankIcon width={width} height={height} color={color} />,
    HeaderArrowLeft: <HeaderArrowLeft width={width} height={height} color={color} />,
    MyAccountIcon: <MyAccountIcon width={width} height={height} color={color} />,
    RefundIcon: <RefundIcon width={width} height={height} color={color} />,
    RupeeIconFilled: <RupeeIconFilled width={width} height={height} color={color} />,
    FaqArrowRight: <FaqArrowRight width={width} height={height} color={color} />,
    MailIcon: <MailIcon width={width} height={height} color={color} />,
    HelpIcon: <HelpIcon width={width} height={height} color={color} />,
    EditIcon: <EditIcon width={width} height={height} color={color} />,
    TransactionHistoryIcon: <TransactionHistoryIcon width={width} height={height} color={color} />,
    BillIcon: <BillIcon width={width} height={height} color={color} />,
    PaymentLinkIcon: <PaymentLinkIcon width={width} height={height} color={color} />,
    CalculatorIcon: <CalculatorIcon width={width} height={height} color={color} />,
    ManageUsersIcon: <ManageUsersIcon width={width} height={height} color={color} />,
    RupeeIconRepeated: <RupeeIconRepeated width={width} height={height} color={color} />,
    RupeeTabIcon: <RupeeTabIcon width={width} height={height} color={color} />,
    HomeTabIcon: <HomeTabIcon width={width} height={height} color={color} />,
    MoreTabIcon: <MoreTabIcon width={width} height={height} color={color} />,
    QrTabIcon: <QrTabIcon width={width} height={height} color={color} />,
    TimerIcon: <TimerIcon width={width} height={height} color={color} />,
    MobileIcon: <MobileIcon width={width} height={height} color={color} />,
    AddUserIcon: <AddUserIcon width={width} height={height} color={color} />,
    ItemChecked: <ItemChecked width={width} height={height} color={color} />,
    ItemUnChecked: <ItemUnChecked width={width} height={height} color={color} />,
    MoreIcon: <MoreIcon width={width} height={height} color={color} />,
    DeleteIcon: <DeleteIcon width={width} height={height} color={color} />,
    ContactsIcon: <ContactsIcon width={width} height={height} color={color} />,
    ProfileIconFilled: <ProfileIconFilled width={width} height={height} color={color} />,
    CheckboxOff: <CheckboxOff width={width} height={height} color={color} />,
    CheckboxOn: <CheckboxOn width={width} height={height} color={color} />,
    error: <Error />,
    document: <Document color={color} />,
    documentWithDot: <DocumentWithDot />,
    bizzLogo: <BizzLogo color={color} />,
    errorTxn: <ErrorTxn color={color} />,
    errorbadge: <ErrorBadge color={color} />,
    RefreshIcon: <RefreshIcon width={width} height={height} color={color} />,
    Logout: <Logout width={width} height={height} color={color} />,
    SuccessIconTick: <SuccessIconTick width={width} height={height} color={color} />,
    SuccessIconTickSmall: <SuccessIconTickSmall width={width} height={height} color={color} />,
    downloadFile: <DownloadFile />,
    NoDeviceLinked: <NoDeviceLinked width={width} height={height} color={color} />,
    WarningIcon: <WarningIcon width={width} height={height} color={color} />,
    WarningIconError: <WarningIconError width={width} height={height} color={color} />,
    triangle: <Triangle />,
    report: <Report color={color} />,
    InfoIcon: <InfoIcon color={color} />,
    calender: <Calendar />,
    SearchIcon: <SearchIcon width={width} height={height} color={color} />,
    DocumentIcon: <DocumentIcon width={width} height={height} color={color} />,
    ChatbotAwareness: <ChatbotAwareness width={width} height={height} color={color} />,
    ChatIcon: <ChatIcon width={width} height={height} color={color} />,
    CaretIcon: <CaretIcon width={width} height={height} color={color} />,

    RupeeIconBillPayment: <RupeeIconBillPayment />,
    BillPaymentRupeeIcon: <BillPaymentRupeeIcon width={width} height={height} color={color} />,

    // bill payment screen icons goes below
    FAST_TAG_ICON: <FastTag width={width} height={height} color={color} />,
    MOBILE_ICON: <Mobile width={width} height={height} color={color} />,
    DTH_ICON: <Dth width={width} height={height} color={color} />,
    DATA_CARD_ICON: <DataCard width={width} height={height} color={color} />,
    ELECTRICITY_ICON: <Electricity width={width} height={height} color={color} />,
    BROADBAND_ICON: <Broadband width={width} height={height} color={color} />,
    WATER_ICON: <Water width={width} height={height} color={color} />,
    LANDLINE_ICON: <Landline width={width} height={height} color={color} />,
    TAX_ICON: <Tax width={width} height={height} color={color} />,
    HOUSING_ICON: <HousingSociety width={width} height={height} color={color} />,
    JIO_ICON: <Jio width={width} height={height} color={color} />,
    EDUCATION_ICON: <Education width={width} height={height} color={color} />,
    CABLE_ICON: <Cable width={width} height={height} color={color} />,
    RENTALS_ICON: <Rentals width={width} height={height} color={color} />,
    GAS_ICON: <Gas width={width} height={height} color={color} />,
    CREDIT_CARD_ICON: <CreditCard width={width} height={height} color={color} />,
    MUTUAL_FUND_ICON: <MutualFund width={width} height={height} color={color} />,
    INSURANCE_ICON: <Insurance width={width} height={height} color={color} />,
    LOAN_ICON: <Loan width={width} height={height} color={color} />,
    RECURRING_DEPOSITS_ICON: <RecurringDeposits width={width} height={height} color={color} />,
    CYLINDER_ICON: <Cylinder width={width} height={height} color={color} />,
    CHARITY_ICON: <Charity width={width} height={height} color={color} />,
    SUBSCRIPTION_ICON: <Subscription width={width} height={height} color={color} />,
    TOLL_ICON: <Toll width={width} height={height} color={color} />,
    HOSPITALITY_ICON: <Hospitality width={width} height={height} color={color} />,
    CLUBS_ICON: <Clubs width={width} height={height} color={color} />,
    GIFT_CARD_ICON: <GiftCard width={width} height={height} color={color} />,
    GOOGLE_PLAY_ICON: <GooglePlay width={width} height={height} color={color} />,
    BhimIcon: <BhimIcon width={width} height={height} color={color} />,
    SuccessIconFilled: <SuccessIconFilled width={width} height={height} color={color} />,
    PendingIconFilled: <PendingIconFilled width={width} height={height} color={color} />,
    FailedIconFilled: <FailedIconFilled width={width} height={height} color={color} />,
    TouchIcon: <TouchIcon width={width} height={height} color={color} />,
    PaymentIcon: <PaymentIcon width={width} height={height} color={color} />,
    NoAdditionalCharges: <NoAdditionalCharges width={width} height={height} color={color} />,
    InstantOnboard: <InstantOnboard width={width} height={height} color={color} />,
    Chatbot: <ChatbotIcon width={width} height={height} color={color} />,
    BluetoothIcon: <BluetoothIcon width={width} height={height} />,
    BluetoothSymbol: <BluetoothSymbol width={width} height={height} color={color} />,
  }
  const retData = SvgList[imageName]
  return retData ? retData : <NoTransaction color={color} textColor={textColor} />
})
